export type AuthButtonChecker = (key: string) => boolean
export interface AuthButtonPermission {
  name: string
  code: string
}
export type AuthButtonPermissionInput = string | AuthButtonPermission

let checker: AuthButtonChecker = () => true

export function configureAuthButtonChecker(nextChecker: AuthButtonChecker) {
  checker = nextChecker
}

export function useAuthButtons(permission?: AuthButtonPermissionInput) {
  const key = typeof permission === 'string' ? permission : permission?.code
  return key ? checker(key) : true
}
